'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    height: auto;\n  '], ['\n    height: auto;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _H = require('UIComponents/elements/headings/H1');

var _H2 = _interopRequireDefault(_H);

var _H3 = require('UIComponents/elements/headings/H5');

var _H4 = _interopRequireDefault(_H3);

var _colors = require('HubStyleTokens/colors');

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Breakpoints = require('pricing-pages-unified-ui/constants/Breakpoints');

var _GuaranteeBlob = require('./GuaranteeBlob');

var _GuaranteeBlob2 = _interopRequireDefault(_GuaranteeBlob);

var _SignupButton = require('pricing-pages-unified-ui/components/public-only/SignupButton');

var _SignupButton2 = _interopRequireDefault(_SignupButton);

var _EnvironmentWrapper = require('pricing-pages-unified-ui/components/EnvironmentWrapper');

var _EnvironmentWrapper2 = _interopRequireDefault(_EnvironmentWrapper);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Guarantee = (0, _styledComponents2.default)(function (_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      header = _ref.header,
      body = _ref.body;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_UIIcon2.default, { name: icon, color: _colors.FLINT, size: 'medium', className: 'm-bottom-2' })
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _H4.default,
        null,
        header
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      body
    )
  );
}).withConfig({
  displayName: 'GuaranteeSection__Guarantee'
})(['width:240px;text-align:center;@media (max-width:', 'px){&:not(:last-child){margin-bottom:10px;}}'], _Breakpoints.GUARANTEE_SECTION);

var GuaranteeRow = _styledComponents2.default.div.withConfig({
  displayName: 'GuaranteeSection__GuaranteeRow'
})(['display:flex;justify-content:space-between;flex-wrap:nowrap;margin-bottom:24px;width:100%;max-width:870px;@media (max-width:', 'px){flex-direction:column;align-items:center;}'], _Breakpoints.GUARANTEE_SECTION);

var GuaranteeSection = (0, _styledComponents2.default)(function (_ref2) {
  var className = _ref2.className;
  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(_GuaranteeBlob2.default, null),
    _react2.default.createElement(
      _H2.default,
      { className: 'm-bottom-12 text-center' },
      _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.guarantee' })
    ),
    _react2.default.createElement(
      GuaranteeRow,
      null,
      _react2.default.createElement(Guarantee, {
        icon: 'lists',
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.unlimitedHeader' }),
        body: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.unlimitedBody' })
      }),
      _react2.default.createElement(Guarantee, {
        icon: 'tag',
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.freeHeader' }),
        body: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.freeBody' })
      }),
      _react2.default.createElement(Guarantee, {
        icon: 'generateChart',
        header: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.dataHeader' }),
        body: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.pages.crm.dataBody' })
      })
    ),
    _react2.default.createElement(_EnvironmentWrapper2.default, {
      publicNode: _react2.default.createElement(_SignupButton2.default, { sourceId: 'crm-pricing-middle' })
    })
  );
}).withConfig({
  displayName: 'GuaranteeSection'
})(['display:flex;text-align:center;flex-direction:column;align-items:center;margin-top:80px;margin-bottom:30px;padding:40px 16px;width:100%;height:400px;position:relative;z-index:1;@media (max-width:', 'px){background-color:', ';margin-top:40px;margin-bottom:0;padding-bottom:2.1em;}', ';'], _Breakpoints.GUARANTEE_SECTION, _colors.GYPSUM, _responsiveBreakpoints2.default.tablet(_templateObject));

exports.default = GuaranteeSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/free-tools-page/GuaranteeSection.js
// module id = 645
// module chunks = 3 4